import React, { Component } from 'react'

import Button from './button'

class ButtonContainer extends Component {

  render() {
    return (
      <Button {...this.props} />
    )
  }

}

export default ButtonContainer



/** WEBPACK FOOTER **
 ** ./src/components/button/button-container.js
 **/